import React from 'react';
import { fmt, tradeValue, insuranceValue } from '../data';

export default function ValueBadges({ market, size = 'sm' }) {
  const badges = [
    { label: 'Market', value: fmt(market), color: 'var(--market)', bg: 'rgba(24,95,165,0.08)' },
    { label: 'Trade', value: fmt(tradeValue(market)), color: 'var(--trade)', bg: 'rgba(60,52,137,0.08)' },
    { label: 'Insurance', value: fmt(insuranceValue(market)), color: 'var(--insure)', bg: 'rgba(15,110,86,0.08)' },
  ];
  const pad = size === 'lg' ? '10px 16px' : '5px 10px';
  const fs = size === 'lg' ? 15 : 12;
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {badges.map(b => (
        <div key={b.label} style={{ background: b.bg, borderRadius: 8, padding: pad, border: `0.5px solid ${b.color}22` }}>
          <div style={{ fontSize: size === 'lg' ? 11 : 10, color: b.color, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>{b.label}</div>
          <div style={{ fontSize: fs, fontWeight: 600, color: b.color }}>{b.value}</div>
        </div>
      ))}
    </div>
  );
}
